import React, { useState } from "react";
import ReactDOM from "react-dom";
import Navbar from "./components/Navbar";
import OwnItGame from "./OwnItGame";
const Main = () => {
  const [lang, setLang] = useState("ru");
  return (
    <React.StrictMode>
      <Navbar
        lang={lang}
        onLanguageSelect={(lang) => {
          setLang(lang);
        }}
      />
      <OwnItGame lang={lang} />
    </React.StrictMode>
  );
};
ReactDOM.render(<Main />, document.getElementById("root"));
